@import "./general-search-result-product-styles";
@import "../../public/product-card/subcomponents/made-in-america-badge/made-in-america-badge.scss";
@import "../../../../../styles/variables.scss";

.product-card {
  &-header {
    display: flex;
    justify-content: space-between;
  }

  &-eshop {
    display: flex;
    margin-top: 16px;
  }

  &-eshop__btn {
    margin: 0 -4px;

    a {
      text-decoration: none;
    }
  }

  &-eshop__btn--desktop {
    display: none;
  }

  &-eshop__btn--mobile {
    display: flex;
    margin-top: 16px;
  }

  &-divider {
    margin-top: 16px;
  }

  &-divider {
    margin-top: 16px;
  }

  &__add-to-my-list {
    margin-top: 12px;
  }

  &__cta-bottom-section {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  &__labels {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  &__circular-label {
    display: none;
  }

  @media (min-width: 780px) {
    &-price-info {
      margin-top: 0px;
    }
    &-eshop__btn {
      margin-top: 16px;
    }
    &-eshop__btn--mobile {
      display: none;
    }
    &-eshop__btn--desktop {
      display: flex;
    }
  }
}

@media (max-width: $uiaas-tablet) {
  .result-card__image-container {
    position: relative;
  }

  .product-card__add-to-my-list {
    margin-top: 0;
  }
}

@media (min-width: $uiaas-tablet) {
  .result-card__image-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .e-commerce-section,
  .produktnet-section {
    &__price {
      justify-content: center;
      margin: 0;
      margin-bottom: 9px;
    }

    &__availability {
      flex-direction: row;
      justify-content: center;
      padding: 7.5px;
      width: 100%;

      &:hover,
      &:focus {
        border: 1px solid $svs-dark-sky-blue;
        border-radius: 2px;
        padding: 6.5px;
      }
    }
  }
}

.result-card__eol-tag {
  margin-bottom: 8px;
}

.offites-cta-button {
  margin-top: 1rem;
  margin-left: auto;
}

// Combinations
.grid-view {
  .result-card__image-container {
    position: relative;
  }
  .product-card__add-to-my-list {
    margin-top: 16px;
  }
}
